import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyPT() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Voltar ao App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Politica de Privacidade</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Ultima atualizacao: {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Controlador de Dados</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>O controlador de dados e:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Nome:</strong> Puretech s.r.o.</p>
                  <p><strong>Numero de Registro:</strong> 05503795</p>
                  <p><strong>Localizacao:</strong> Republica Tcheca</p>
                  <p><strong>Contato:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informacoes que Coletamos</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Informacoes da Conta:</strong> Quando voce cria uma conta, coletamos seu endereco de e-mail e quaisquer informacoes de perfil que voce escolher fornecer.
                </p>
                <p className="leading-relaxed">
                  <strong>Dados de Uso:</strong> Coletamos informacoes sobre como voce usa nosso servico, incluindo tarefas criadas, projetos gerenciados e padroes de uso de recursos.
                </p>
                <p className="leading-relaxed">
                  <strong>Informacoes de Pagamento:</strong> O processamento de pagamentos e realizado pelo Polar. Nao armazenamos os dados do seu cartao de pagamento em nossos servidores.
                </p>
                <p className="leading-relaxed">
                  <strong>Dados Tecnicos:</strong> Coletamos automaticamente certas informacoes tecnicas, incluindo endereco IP, tipo de navegador, sistema operacional e informacoes do dispositivo.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Como Usamos Suas Informacoes</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Usamos as informacoes que coletamos para:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Fornecer, manter e melhorar nossos servicos</li>
                  <li>Processar transacoes e gerenciar assinaturas</li>
                  <li>Enviar avisos tecnicos e mensagens de suporte</li>
                  <li>Responder aos seus comentarios e perguntas</li>
                  <li>Analisar padroes de uso para melhorar a experiencia do usuario</li>
                  <li>Fazer cumprir nossos termos e condicoes</li>
                  <li>Cumprir obrigacoes legais</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Compartilhamento de Informacoes</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nao vendemos, trocamos ou transferimos suas informacoes pessoais para terceiros, exceto conforme descrito nesta politica:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Provedores de Servicos:</strong> Podemos compartilhar informacoes com terceiros confiaveis que nos auxiliam na operacao do nosso servico (por exemplo, Polar para processamento de pagamentos, Supabase para servicos de banco de dados)</li>
                  <li><strong>Requisitos Legais:</strong> Podemos divulgar informacoes quando exigido por lei ou para proteger nossos direitos</li>
                  <li><strong>Transferencias Comerciais:</strong> Em caso de fusao, aquisicao ou venda de ativos, as informacoes dos usuarios podem ser transferidas</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Seguranca de Dados</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Implementamos medidas de seguranca tecnicas e organizacionais apropriadas para proteger suas informacoes pessoais contra acesso nao autorizado, alteracao, divulgacao ou destruicao. No entanto, nenhum metodo de transmissao pela internet e 100% seguro.
                </p>
                <p className="leading-relaxed">
                  <strong>Resposta a Violacao de Seguranca:</strong> Em caso de violacao de dados pessoais, cumpriremos o GDPR:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Relatar o incidente a autoridade supervisora dentro de 72 horas apos a descoberta</li>
                  <li>Notificar os usuarios afetados se a violacao representar alto risco aos seus direitos e liberdades</li>
                  <li>Tomar medidas para minimizar o impacto e prevenir incidentes futuros</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Retencao de Dados</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Retemos suas informacoes pessoais pelo tempo necessario para fornecer nossos servicos. Os periodos especificos de retencao sao:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dados da conta:</strong> Duracao do servico + 30 dias apos a exclusao da conta</li>
                  <li><strong>Conteudo de tarefas (sticky notes):</strong> Ate ser excluido por voce ou encerramento da conta</li>
                  <li><strong>Registros de pagamento:</strong> 7 anos (requisito da lei contabil tcheca)</li>
                  <li><strong>Dados de analise:</strong> Ate 26 meses</li>
                  <li><strong>Dados de backup:</strong> Podem persistir ate 90 dias apos a exclusao primaria</li>
                  <li><strong>Dados anonimizados:</strong> Retidos indefinidamente para fins estatisticos</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Seus Direitos sob o GDPR</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Voce tem o direito de:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Acessar as informacoes pessoais que mantemos sobre voce</li>
                  <li>Corrigir quaisquer informacoes pessoais imprecisas</li>
                  <li>Solicitar a exclusao de suas informacoes pessoais</li>
                  <li>Opor-se ou restringir o processamento de suas informacoes</li>
                  <li>Portabilidade de dados (receber uma copia de seus dados em formato estruturado)</li>
                  <li>Retirar o consentimento a qualquer momento</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies e Rastreamento</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Usamos cookies e tecnologias de rastreamento semelhantes para melhorar sua experiencia. Tipos de cookies que usamos:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Cookies essenciais:</strong> Necessarios para a funcionalidade do servico (autenticacao, login)</li>
                  <li><strong>Cookies de analise:</strong> Nos ajudam a entender como voce usa nosso servico (voce pode recusar)</li>
                  <li><strong>Cookies de terceiros:</strong> Google OAuth, Polar para pagamentos</li>
                </ul>
                <p className="leading-relaxed">
                  Voce pode controlar as configuracoes de cookies atraves das preferencias do seu navegador ou do nosso banner de cookies na primeira visita.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Servicos de Terceiros</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Nosso servico integra-se com servicos de terceiros:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Para autenticacao (sujeito a politica de privacidade do Google)</li>
                  <li><strong>Polar:</strong> Para processamento de pagamentos (sujeito a politica de privacidade do Polar)</li>
                  <li><strong>Supabase:</strong> Para servicos de banco de dados e autenticacao</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Privacidade de Criancas</h2>
              <p className="leading-relaxed">
                Nosso servico nao e destinado a criancas menores de 16 anos. Nao coletamos intencionalmente informacoes pessoais de criancas menores de 16 anos. Se voce e pai ou responsavel e acredita que seu filho nos forneceu informacoes pessoais, entre em contato conosco em support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Transferencias Internacionais de Dados</h2>
              <p className="leading-relaxed">
                Suas informacoes podem ser transferidas e processadas em paises diferentes do seu pais de residencia. Garantimos que salvaguardas apropriadas estejam em vigor para proteger suas informacoes pessoais de acordo com as leis de protecao de dados aplicaveis.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Alteracoes nesta Politica</h2>
              <p className="leading-relaxed">
                Podemos atualizar esta politica de privacidade periodicamente. Notificaremos voce sobre quaisquer alteracoes materiais publicando a nova politica nesta pagina e atualizando a data de "Ultima atualizacao".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Tomada de Decisao Automatizada</h2>
              <p className="leading-relaxed">
                Nosso servico usa algoritmos de IA para gerar sugestoes de tarefas. Este recurso e puramente assistivo e nao cria decisoes com efeitos legais ou significativos sobre os usuarios. Voce pode optar por nao usar as sugestoes a qualquer momento.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Autoridade Supervisora</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Voce tem o direito de apresentar uma reclamacao a autoridade supervisora para protecao de dados:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Escritorio Tcheco para Protecao de Dados Pessoais (UOOU)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Praga 7</p>
                  <p className="text-sm">Web: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">Email: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Como Exercer Seus Direitos</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Para exercer seus direitos sob o GDPR (acesso a dados, retificacao, exclusao, portabilidade, objecao, etc.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Envie-nos uma solicitacao em <strong>support@simplestickers.app</strong></li>
                  <li>Responderemos dentro de <strong>1 mes</strong> apos receber sua solicitacao</li>
                  <li>Podemos pedir que voce verifique sua identidade</li>
                  <li>O servico e <strong>gratuito</strong> (a menos que a solicitacao seja manifestamente infundada ou excessiva)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Entre em Contato</h2>
              <p className="leading-relaxed">
                Se voce tiver alguma duvida sobre esta politica de privacidade ou nossas praticas de dados, entre em contato conosco:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>Email:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Para todas as perguntas sobre privacidade, solicitacoes de dados, suporte e outras consultas
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
